import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { listeClients } from "../actions/clientsActions";
import { saveVariableGlo } from "../actions/chariotActions";
import "../RechClient.css";

const RechClient = () => {
  const [search, setSearch] = useState("");
  const [cliTab, setCliTab] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const params = location.state || {};

  const { clients, loading } = useSelector((state) => state.clientsListeState);
  const { client } = useSelector((state) => state.client);

  useEffect(() => {
    document.title =
      params.langue === "F" ? "Liste des Clients" : "قائمـــة الحرفاء";

    if (!client) {
      navigate("/");
    }
  }, []);

  useEffect(() => {
    setCliTab([]);

    if (search === "") {
      dispatch(listeClients());
      if (client?.nivcli_cloud === "R" && client?.REP_GERCLI === "N") {
        clients?.forEach((cli) => {
          if (cli.cod_rep === client.cod_cli) {
            setCliTab((prev) => [...prev, cli]);
          }
        });
      } else {
        setCliTab(clients);
      }
    } else {
      clients?.forEach((cli) => {
        if (client?.nivcli_cloud === "R" && client?.REP_GERCLI === "N") {
          if (
            cli.nom_cli.toUpperCase().includes(search.toUpperCase()) &&
            cli.cod_rep === client.cod_cli
          ) {
            setCliTab((prev) => [...prev, cli]);
          }
        } else if (cli.nom_cli.toUpperCase().includes(search.toUpperCase())) {
          setCliTab((prev) => [...prev, cli]);
        }
      });
    }
  }, [client, search]);

  const handleClientClick = (item) => {
    if (params?.fn === "rap") {
      navigate("/rapport-cree", {
        state: {
          code: item.cod_cli,
          rep: params.rep,
          nom: item.nom_cli,
        },
      });
    } else {
      dispatch(saveVariableGlo(item));
      navigate("/ClientDetail", { state: { code: item.cod_cli } });
    }
  };

  return (
    <div className="rech-client-container">
      <div className="search-container">
        <input
          type="text"
          placeholder="Chercher Client"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="search-input"
        />
      </div>

      {loading ? (
        <div className="loading-container">
          <div className="spinner"></div>
        </div>
      ) : (
        <div className="results-container">
          <div className="table-header">
            <div className="header-cell code-cell">Code Client</div>
            <div className="header-cell name-cell">Nom</div>
            <div className="header-cell abrv-cell">Abrv</div>
          </div>

          <div className="clients-list">
            {cliTab?.map((item, index) => (
              <div
                key={item.cod_cli}
                className={`client-item ${index % 2 === 0 ? "even" : "odd"}`}
                onClick={() => handleClientClick(item)}
              >
                <div className="item-cell code-cell">{item.cod_cli}</div>
                <div className="item-cell name-cell">{item.nom_cli}</div>
                <div className="item-cell abrv-cell">{item.abrv_cli}</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default RechClient;
